export class AnchorNotFoundError extends Error {
  constructor() {
    super(`Search anchor not found`)
    this.name = 'ParamsInvalid'
  }
}

export class ParamsInvalidError extends Error {
  constructor() {
    super(`Search params invalid`)
    this.name = 'ParamsInvalid'
  }
}

export type AnySearchError = AnchorNotFoundError | ParamsInvalidError

/**
 * Check whether an error is a known (non-fatal) search error
 */
export const isAnySearchError = (error: unknown): error is AnySearchError =>
  error instanceof AnchorNotFoundError || error instanceof ParamsInvalidError
